import GoogleMapsLoader from 'google-maps';
import isIe from '@/scripts/utils/detect-ie';
import 'nodelist-foreach-polyfill';
import mapStyles from './styles.json';
import './googleMaps.scss';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-role*="google-maps-container"]').forEach((el) => {
    const {
      key, options, coords, markerImage,
    } = el.dataset;
    const { lat, lng } = JSON.parse(coords);
    GoogleMapsLoader.KEY = key;
    GoogleMapsLoader.VERSION = 'weekly';
    return GoogleMapsLoader.load((google) => {
      const mapEl = el.querySelector('[data-map]');
      const panoramaEl = el.querySelector('[data-panorama]');
      const center = new google.maps.LatLng(lat, lng);
      const map = new google.maps.Map(mapEl, {
        center,
        styles: mapStyles,
        ...JSON.parse(options),
      });
      const marker = new google.maps.Marker({
        position: center,
        icon: isIe() ? null : markerImage,
        optimized: false,
        origin: isIe() ? null : new google.maps.Point(16, 16),
      });
      marker.setMap(map);
      if (panoramaEl) {
        const panoOptions = JSON.parse(el.dataset.panoramaOptions);
        const panorama = new google.maps.StreetViewPanorama(panoramaEl, {
          position: { lat: panoOptions.lat, lng: panoOptions.lng },
          pov: {
            heading: panoOptions.heading,
            pitch: panoOptions.pitch,
          },
        });
        map.setStreetView(panorama);
      }
    });
  });
});
